/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Enabled_ToastInputs */

const en_live_caption_enabled_toast = /** @type {(inputs: Live_Caption_Enabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live captioning enabled.`)
};

const fr_live_caption_enabled_toast = /** @type {(inputs: Live_Caption_Enabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-titrage en direct activé.`)
};

const de_live_caption_enabled_toast = /** @type {(inputs: Live_Caption_Enabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Untertitelung aktiviert.`)
};

const it_live_caption_enabled_toast = /** @type {(inputs: Live_Caption_Enabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottotitoli in tempo reale attivati.`)
};

const ru_live_caption_enabled_toast = /** @type {(inputs: Live_Caption_Enabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включена функция субтитров в реальном времени.`)
};

const es_live_caption_enabled_toast = /** @type {(inputs: Live_Caption_Enabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtítulos en directo activados.`)
};

const zh_cn2_live_caption_enabled_toast = /** @type {(inputs: Live_Caption_Enabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已启用实时字幕。`)
};

const ja_live_caption_enabled_toast = /** @type {(inputs: Live_Caption_Enabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リアルタイム字幕が有効になっています。`)
};

const hi_live_caption_enabled_toast = /** @type {(inputs: Live_Caption_Enabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइव कैप्शनिंग चालू है।`)
};

const pt_pt2_live_caption_enabled_toast = /** @type {(inputs: Live_Caption_Enabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendas ao vivo ativadas.`)
};

/**
* | output |
* | --- |
* | "Live captioning enabled." |
*
* @param {Live_Caption_Enabled_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_enabled_toast = /** @type {((inputs?: Live_Caption_Enabled_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Enabled_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_enabled_toast(inputs)
	if (locale === "de") return de_live_caption_enabled_toast(inputs)
	if (locale === "it") return it_live_caption_enabled_toast(inputs)
	if (locale === "ru") return ru_live_caption_enabled_toast(inputs)
	if (locale === "es") return es_live_caption_enabled_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_enabled_toast(inputs)
	if (locale === "ja") return ja_live_caption_enabled_toast(inputs)
	if (locale === "hi") return hi_live_caption_enabled_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_enabled_toast(inputs)
	return en_live_caption_enabled_toast(inputs)
});